import request from '@/api/request'
export default {
    createModel(params) {
        return request({
            url: '/models/create',
            method: 'post',
            data: params
        })
    },
    getModelById(params){
        return request({
            url: '/models/getById',
            method: 'get',
            params: params
        })
    },
    getAll() {
        return request({
            url: '/models/getAll',
            method: 'get',
        })
    },
    /**
     * 上传模型文件到 /models/uploadModel
     * 后端方法签名：@PostMapping("/uploadModel") uploadModel(@RequestParam("file") MultipartFile file)
     */
    deleteModel(params) {
        return request({
            url: '/models/delete',
            method: 'post',
            params: params
        })
    },
    uploadModel(file, onProgress) {
        console.log('uploadModel 调用，文件信息:', {
            name: file.name,
            size: file.size,
            type: file.type
        });
        const formData = new FormData();
        formData.append('file', file);
        console.log('FormData 创建完成，keys:', Array.from(formData.keys()));

        return request({
            url: '/models/uploadModel',
            method: 'post',
            data: formData,
            timeout: 300000, // 5 分钟超时，避免大文件上传被中断
            headers: {
                // 不手动设置 Content-Type，让浏览器自动设置 multipart/form-data 和 boundary
            },
            onUploadProgress: (progressEvent) => {
                console.log('上传进度事件:', {
                    loaded: progressEvent.loaded,
                    total: progressEvent.total,
                    percent: progressEvent.total > 0 ? Math.round((progressEvent.loaded * 100) / progressEvent.total) : 0
                });
                if (onProgress && progressEvent.total > 0) {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(percent, progressEvent);
                }
            }
        });
    },
}